import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseEventInboxCalling } from 'entities/Inbox/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventInboxCalling = () => {
  const { inboxesStore, websocket } = useEntitiesContext()

  const handle = (data: IResponseEventInboxCalling) => {
    inboxesStore.updateInboxCalling(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.InboxCalling, handle), [])
}
